module.exports = {
	API_URL: 'https://vetopedia.org/api/'
}
